module.exports = __webpack_public_path__ + "static/media/bandeira_elo.286b752e.svg";